import { useEffect, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

export default function useEstatisticasPesquisaClima(
  entidadeId,
  { enabled = true, filtros, refreshToken = 0 } = {}
) {
  const [isLoading, setIsLoading] = useState(false);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    if (!enabled || !entidadeId) {
      setDados(null);
      return undefined;
    }

    let ativo = true;

    const carregarDados = async () => {
      setIsLoading(true);
      try {
        const response = await http.get('/PesquisaClima/ObterEstatisticas', {
          params: { id: entidadeId, ...filtros },
        });

        if (ativo) {
          setDados(response.data);
        }
      } catch (err) {
        if (ativo) {
          errorHandler(err);
        }
      } finally {
        if (ativo) {
          setIsLoading(false);
        }
      }
    };

    carregarDados();

    return () => {
      ativo = false;
    };
  }, [enabled, entidadeId, filtros, refreshToken]);

  return { dados, isLoading };
}
